import { useState } from "react";
import { Run } from "./Run";
import { createEntityStore } from "../../common/entityStore";
import { today, withSameProp } from "../../common/utils";
import { Grid } from "@mui/material";
import { propDateField } from "../../common/entityStoreForm";
import { propRequired, propValidValue, propValueValidator } from "../../common/entityStoreValidators";
import { useSimpleDialog, yesNoButtons } from "../../common/dialog";
import { RunLogEntry } from "./common";
import { LogEntryType } from "../../common/enum";
import { dayjs } from "../../common/config";

export const DunningRunPage = withSameProp("fake", () => (props: { fake?: boolean }) => {
    const [useParamsStore] = useState(() => createEntityStore<RunParams>({
        data: { runDate: today(), invcDate: today(), dueDate: today() },
        id: null,
        propValidators: [
            propValidValue("runDate", "runDateFormatted"),
            propValidValue("invcDate", "invcDateFormatted"),
            propValidValue("dueDate", "dueDateFormatted"),
            propRequired("runDate"),
            propRequired("invcDate"),
            propRequired("dueDate"),
            propValueValidator("invcDate", (p, e) => p && e.runDate && dayjs.tz(p).isBefore(dayjs.tz(e.runDate)) &&
                "Invoice date must be greater or equal to run date."),
            propValueValidator("dueDate", (p, e) => p && e.invcDate && dayjs.tz(p).isBefore(dayjs.tz(e.invcDate)) &&
                "Due date must be greater or equal to invoice date."),
        ]
    }));
    const simpleDialog = useSimpleDialog();
    async function processResult(result: {
        logEntries: RunLogEntry[];
        projectIdsWithNoDunningLevels: number[] | null;
        projectIdsWithNoCreditLimits: number[] | null;
    }, runAgain: () => void) {
        const oldDunLvlIds = useParamsStore.getState().clientData.ignoreProjectIdsWithNoDunningLevels || [];
        const newDunLvlIds = result.projectIdsWithNoDunningLevels || [];
        const oldCredLimIds = useParamsStore.getState().clientData.ignoreProjectIdsWithNoCreditLimits || [];
        const newCredLimIds = result.projectIdsWithNoCreditLimits || [];
        if (newDunLvlIds.length > 0 || newCredLimIds.length > 0) {
            const errors = result.logEntries.filter(p => p.type === LogEntryType.Error).map(p => p.message.trim()).join("\n\n").trim();
            simpleDialog.show("Warning", errors + "\n\nDo you want to continue?", undefined, yesNoButtons(() => {
                useParamsStore.getState().setClientDataProp("ignoreProjectIdsWithNoDunningLevels", oldDunLvlIds.concat(newDunLvlIds));
                useParamsStore.getState().setClientDataProp("ignoreProjectIdsWithNoCreditLimits", oldCredLimIds.concat(newCredLimIds));
                runAgain();
            }));
        }
        else {
            useParamsStore.getState().setClientDataProp("ignoreProjectIdsWithNoDunningLevels", undefined);
            useParamsStore.getState().setClientDataProp("ignoreProjectIdsWithNoCreditLimits", undefined);
        }
    }
    function renderParams() {
        return <>
            <Grid item xs={12}>{propDateField(useParamsStore)("runDate", "runDateFormatted", "Run date")}</Grid>
            <Grid item xs={12}>{propDateField(useParamsStore)("invcDate", "invcDateFormatted", "Invoice date")}</Grid>
            <Grid item xs={12}>{propDateField(useParamsStore)("dueDate", "dueDateFormatted", "Due date")}</Grid>
        </>;
    }
    return <>
        {simpleDialog.render()}
        <Run name="Dunning run" fake={props.fake} hub="dunningRun"
            useParamsStore={useParamsStore} renderParams={renderParams} processResult={processResult} />
    </>;
});

interface RunParams {
    runDate: string;
    runDateFormatted?: string;
    invcDate: string;
    invcDateFormatted?: string;
    dueDate: string;
    dueDateFormatted?: string;
    ignoreProjectIdsWithNoDunningLevels?: number[];
    ignoreProjectIdsWithNoCreditLimits?: number[];
}
